import moment from "moment";
import BarLineChart from "../../../../components/common/chart/BarLineChart";
import { useQuery } from "../../../../hooks/UseQuery";
import lodash from "lodash";

interface IProps {
  apiData: any;
  target: any;
  tabValue: any;
}

const generateFinancialYearLabels = (date: any) => {
  const year = moment(date).format("YY");
  const nextYear = moment(date).add(1, "year").format("YY");
  const months = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const labels = months.map((month, index) => {
    const yearSuffix = index < 9 ? year : nextYear; // First 9 months are in the current year, last 3 are in the next year
    return `${month}-${yearSuffix}`;
  });

  return labels;
};

const headings = ["MTTR", "MTBF"];
const AnnuallyGraph = ({ apiData, target, tabValue }: IProps) => {
  const { mttrData, mtbfData } = apiData;
  const date = useQuery("date") || "";
  const labels = generateFinancialYearLabels(date);

  return (
    <div>
      <BarLineChart
        datas={tabValue == 0 ? mttrData : mtbfData}
        yTitle={headings[tabValue]}
        xTitle={"Year"}
        labels={labels}
        type={"line"}
        borderTitle={`${headings[tabValue]} GRAPH`}
        headTitle={`HEADING`}
        borderColor={"#38d9a9"}
        borderWidth={2}
        fill={true}
        width={"80vw"}
        margin={"1rem 14rem 5rem 14rem"}
        otherType={"line"}
        otherLabel={`Target : ${target}`}
        otherData={new Array(12).fill(target).map((target: any) => target)}
        otherBorderColor={"#c92a2a"}
        otherFill={false}
        otherBorderWidth={2}
      />
    </div>
  );
};

export default AnnuallyGraph;
